import FaqItem from "./FaqItem";

import { InfoAlert } from "./styles";
import closeIcon from "./imgs/close-icon.svg";
import headerImg from "./imgs/your-stay-banner.webp";

const YourStay = ({
  onClose,
  hotelInfo,
  hotelOptions,
  walletURL,
  onTrackButtonClick
}) => {
  const parseHotelAddress = (address) => {
    return address.split("\n").map((line, i) => <p key={i}>{line}</p>);
  };

  const FAQS = [
    {
      category: "Transportation",
      questions: [
        {
          question: "Do I need to book my own airline reservations?",
          answer:
            "Yes. Mastercard will not be booking any flight reservations. Please provide flight information for transportation arrangements."
        },
        {
          question: "What transportation is included in the program?",
          answer:
            "Group transportation from the hotel to all the venues according to the program."
        },
        {
          question:
            "What happens if I am late and miss the designated transfer?",
          answer:
            "If you miss the designated group transfer, inform a team member immediately."
        },
        {
          question: "Where will I be picked up?",
          answer:
            "Group transportation to the venues according to the program will all pick you up in front of your hotel."
        }
      ]
    },
    {
      category: "Accommodation",
      questions: [
        {
          question: "What costs are included in my accommodation?",
          answer: "Room, applicable taxes (VAT), breakfast, Wi-Fi."
        },
        {
          question:
            "Will I be responsible for covering the hotel costs during my stay in Planica?",
          answer:
            "No, your accommodation is covered. You cover only the additional costs (minibar, phone, bar bills, in-room services, laundry, etc.).\nHotel requires a credit card for incidentals."
        },
        {
          question:
            "If I want to extend my stay an additional night, what do I do?",
          answer:
            "Hotel availability is not guaranteed. Notify the team as soon as possible for assistance."
        }
      ]
    },
    {
      category: "General Information",
      questions: [
        {
          question: "What is the currency in Planica?",
          answer: "Euro (€), credit and debit cards widely accepted."
        },
        {
          question:
            "What is the phone number of the emergency service in Planica?",
          answer: "Police: 113\nFire/Medical: 112"
        },
        {
          question: "What is the weather like in Planica in March?",
          answer:
            "In the mornings we can expect temperatures around 0 degrees celsius, and throughout the day up to 10 degrees celsisus."
        },
        {
          question: "What is the dress code for the program?",
          answer:
            "All activities: Winter casual. Warm, water-resistant clothing recommended (jacket, hat, gloves, winter boots).\nBusiness sessions: Smart casual."
        },
        {
          question:
            "If I have general questions regarding the event, who do I contact?",
          answer: "For general questions, contact: ales.petejan@mastercard.com"
        },
        {
          question: "Who do I contact on-site with event questions?",
          answer: "Mastercard Hospitality Team."
        },
        {
          question: "Who do I contact to change my registration?",
          answer:
            "Use email to log back into the registration site. Save confirmation email for future edits."
        },
        {
          question: "What is YourPass?",
          answer:
            "YourPass uses mobile wallet technology for digital passports.\nProvides event updates via push notifications."
        }
      ]
    }
  ];

  const hotelDetails = hotelInfo?.options?.find(
    (item) => item?.id === hotelOptions?.selectedOptionId
  );

  return (
    <InfoAlert>
      <div className="inner-container">
        <div className="img-container">
          <img src={headerImg} alt="header" />
          <h2>{"Your Stay"}</h2>
        </div>
        <div className="close-button" onClick={onClose}>
          <img src={closeIcon} alt="close" />
        </div>
        <div className="scroll-view">
          <div className="section">
            <p className="bold">{"Accommodation"}</p>
          </div>

          {hotelDetails?.item && (
            <div className="section bg-black hotel-section">
              <img src={hotelDetails?.additionalData?.image} alt="hotel" />
              <div className="hotel-info">
                <p className="bold">{hotelDetails?.item}</p>
                {hotelDetails?.additionalData?.address && (
                  <div>
                    {parseHotelAddress(hotelDetails.additionalData.address)}
                  </div>
                )}
              </div>
            </div>
          )}
          <div className="section">
            <p className="bold">{"FAQs"}</p>
            <div className="faq-container">
              {FAQS.map((faq, index) => (
                <FaqItem
                  key={index}
                  {...faq}
                  isLast={index === FAQS.length - 1}
                  onTrackButtonClick={onTrackButtonClick}
                />
              ))}
            </div>
          </div>
          <div className="section">
            <p className="bold">{"Stay updated"}</p>
            <p>
              {
                "Add your event pass to your mobile wallet and receive real-time event information via push notifications."
              }
            </p>
            <div
              className="button button-fixed"
              onClick={() => {
                onTrackButtonClick?.("open_wallet_pass", "your_stay_modal");
                window.open(walletURL, "_blank");
              }}
            >
              <p>{"Tap here to add"}</p>
            </div>
          </div>
        </div>
      </div>
    </InfoAlert>
  );
};

export default YourStay;
